import { Injectable } from '@angular/core';

/**
 * Last global-search result shown in the top nav dropdown.
 *
 * The nav bar (LangdingPageNavBarComponent) is destroyed and rebuilt on many
 * navigations: userSelected / businessSelected hop through "/" (which redirects
 * to /auth, a different layout) before opening the target page, and the lazy
 * /business feature mounts its own UserLayoutComponent. A fresh nav bar starts
 * with empty result lists, which is why the "history" the user saw before
 * clicking a result vanished. Keeping it here, in a root singleton, lets the
 * new nav bar restore the same dropdown regardless of how it was recreated.
 */
export interface GlobalSearchState {
  term: string;
  users: any[];
  businesses: any[];
  userCount: number;
  businessCount: number;
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchStateService {
  private state: GlobalSearchState | null = null;

  save(state: GlobalSearchState): void {
    this.state = state;
  }

  get(): GlobalSearchState | null {
    return this.state;
  }

  clear(): void {
    this.state = null;
  }
}
